import { render, staticRenderFns } from "./GrupoCompraCadastroCotacaoProdutosList.vue?vue&type=template&id=bcddd0f8&scoped=true&"
import script from "./GrupoCompraCadastroCotacaoProdutosList.vue?vue&type=script&lang=js&"
export * from "./GrupoCompraCadastroCotacaoProdutosList.vue?vue&type=script&lang=js&"
import style0 from "./GrupoCompraCadastroCotacaoProdutosList.vue?vue&type=style&index=0&id=bcddd0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcddd0f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VIcon,VSimpleTable})
